import DateBadge from 'components/Misc/DateBadge';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog, DialogProps } from 'primereact/dialog';
import { ReactNode, useEffect, useState } from 'react';

interface IRowDataProps extends DialogProps {
    modelData: any | null | undefined;
}

const RowDataView: React.FC<IRowDataProps> = ({
    modelData,
    style,
    ...rest
}) => {
    const [rowData, setRowData] = useState<{ field: string; value: unknown }[]>(
        []
    );

    const LargeObjectView: React.FC<{
        children?: React.ReactNode;
    }> = ({ children }) => {
        const [expand, setExpand] = useState(false);
        const content = JSON.stringify(children, null, 4);

        return (
            <div>
                {expand && (
                    <Button
                        style={{ fontSize: '14px' }}
                        label='Hide'
                        icon='pi pi-minus'
                        onClick={() => setExpand(false)}
                    />
                )}
                <pre
                    style={{
                        fontSize: '12px',
                        lineHeight: '16px',
                        maxHeight: expand ? '100%' : '160px',
                        overflowY: expand ? 'auto' : 'hidden',
                    }}
                >
                    {content}
                </pre>
                {content.split('\n').length > 10 && !expand && (
                    <Button
                        style={{ fontSize: '14px' }}
                        label='Show all'
                        icon='pi pi-plus'
                        onClick={() => setExpand(true)}
                    />
                )}
            </div>
        );
    };

    const getFieldBody = (value: unknown): unknown => {
        if (value == null) return <Badge value='null' />;
        switch (typeof value) {
            case 'string':
                try {
                    JSON.parse(value);
                    return (
                        <LargeObjectView>{value as ReactNode}</LargeObjectView>
                    );
                } catch {
                    return value;
                }
            case 'object':
                if (value instanceof Date)
                    return <DateBadge value={value as Date} />;
                return <LargeObjectView>{value as ReactNode}</LargeObjectView>;
            case 'boolean':
                return (
                    <Badge
                        value={
                            value ? 'true' : value == null ? 'null' : 'false'
                        }
                        severity={
                            value
                                ? 'success'
                                : value != null
                                ? 'danger'
                                : undefined
                        }
                    />
                );
            default:
                return value;
        }
    };

    useEffect(() => {
        if (!modelData) return;
        const newData: { field: string; value: any }[] = [];
        Object.keys(modelData).forEach((key) => {
            newData.push({
                field: key,
                value: getFieldBody(modelData[key]),
            });
        });
        newData.sort((a, b) => {
            if (a.field > b.field) return 1;
            if (b.field > a.field) return -1;
            return 0;
        });
        setRowData(newData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelData]);

    return (
        <Dialog style={{ width: '70vw', ...style }} {...rest}>
            {modelData && (
                <DataTable value={rowData}>
                    <Column
                        style={{ maxWidth: '10ch', wordWrap: 'break-word' }}
                        field='field'
                        header='Field'
                    />
                    <Column
                        style={{ maxWidth: '20ch', wordWrap: 'break-word' }}
                        field='value'
                        header='Value'
                    />
                </DataTable>
            )}
        </Dialog>
    );
};

export default RowDataView;
